import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as XLSX from 'xlsx';
import { DigisubservicesService } from '../services/digisubservices.service';

@Component({
  selector: 'app-granth-registration-ledger-report-brifly',
  templateUrl: './granth-registration-ledger-report-brifly.component.html',
  styleUrl: './granth-registration-ledger-report-brifly.component.scss'
})
export class GranthRegistrationLedgerReportBriflyComponent implements OnInit {

  groupedOfficeRepData: any[] = [];
  currentDate = new Date();

  // ================= GRAND TOTALS =================
  grandCopies = 0;
  grandRetCopies = 0;
  grandCompCopies = 0;
  grandBookPrices = 0;
  grandSalePrice = 0;      // NEW: was missing entirely
  grandShipping = 0;
  grandNet = 0;
  grandAmount = 0;
  grandJama = 0;   // Paid
  grandYene = 0;   // Unpaid
  grandCommission = 0;
  grandCredit = 0;

  startDate: any;
  endDate: any;
  reportType: any;

  repName: string[] = [];
  officeRepName: string[] = [];
  bookName: string[] = [];
  bookSellerName: string[] = [];
  selectedCommissionFilter: string[] = [];
  selectedComplimentaryFilter: string[] = [];

  constructor(
    private dialogRef: MatDialogRef<GranthRegistrationLedgerReportBriflyComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService
  ) {}

  ngOnInit(): void {
    this.startDate = this.data?.startDate;
    this.endDate = this.data?.endDate;
    this.reportType = this.data?.reportType;

    this.repName = this.data?.rep_name || [];
    this.officeRepName = this.data?.office_rep_name || [];
    this.bookName = this.data?.book_name || [];
    this.bookSellerName = this.data?.book_seller_name || [];
    this.selectedCommissionFilter = this.data?.commissionFilter || [];
    this.selectedComplimentaryFilter = this.data?.complimentaryFilter || [];

    this.getLedgerReport();
  }

  // ================= HELPER =================
  ConvertToInt(value: any): number {
    return Number(value) || 0;
  }
  ConvertToFloat(value: any): number {
    return parseFloat(value) || 0;
  }

  // ================= API CALL =================
  getLedgerReport() {
    const req = {
      start_date: this.startDate,
      end_date: this.endDate,
      rep_name: this.repName,
      office_rep_name: this.officeRepName,
      book_name: this.bookName,
      book_seller_name: this.bookSellerName,
      commissionFilter: this.selectedCommissionFilter,
      complimentaryFilter: this.selectedComplimentaryFilter
    };

    this.service.getgranthRegistrationLedgerReport(req).subscribe({
      next: (res: any) => {
        if (res?.office_representatives) {
          res.office_representatives.forEach((office: any) => {
            Object.values(office.reps).forEach((rep: any) => {
              rep.records = (rep.records || []).map((d: any) => ({
                ...d,
                totalAmount:
                  this.ConvertToFloat(d.total) + this.ConvertToFloat(d.shipping_charges)
              }));
            });
          });

          this.bindPhpGroupedData(res);
        }
      },
      error: err => console.error('API Error', err)
    });
  }

  // ================= BIND PHP GROUPED DATA =================
  bindPhpGroupedData(response: any) {
    this.resetGrandTotals();

    this.groupedOfficeRepData = response.office_representatives.map((office: any) => {

      const officeTotals: any = {
        totalSale: 0,
        totalReturn: 0,
        totalComp: 0,
        totalBookp: 0,
        totalSalePriceSum: 0,   // NEW
        totalShipping: 0,
        totalNet: 0,
        totalAmount: 0,
        totalReceipt: 0,
        totalPending: 0,
        totalCommission: 0,
        totalCredit: 0
      };

      const reps = Object.values(office.reps).map((rep: any) => {

        const totalSalePriceSum = (rep.records || []).reduce(
          (sum: number, r: any) => sum + this.ConvertToFloat(r.sale_price),
          0
        );

        const repTotals: any = {
          totalSale: Number(rep.totalBookCopies) || 0,
          totalReturn: Number(rep.totalBookReturnCopies) || 0,
          totalComp: Number(rep.totalCompCopies) || 0,
          totalBookp: Number(rep.totalBookPrice) || 0,
          totalSalePriceSum,                                   // NEW
          totalShipping: Number(rep.totalShipping) || 0,
          totalNet: Number(rep.totalNet) || 0,
          totalAmount: (rep.records || []).reduce(
            (sum: number, r: any) => sum + this.ConvertToInt(r.totalAmount),
            0
          ),
          totalReceipt: Number(rep.totalReceived) || 0,
          totalPending: Number(rep.totalPending) || 0,
          totalCommission: Number(rep.totalCommission) || 0,
          totalCredit: Number(rep.totalCredit) || 0
        };

        // ➕ ADD REP TOTAL TO OFFICE TOTAL
        Object.keys(repTotals).forEach(key => officeTotals[key] += repTotals[key]);

        return {
          rep_name: rep.rep_name,
          records: rep.records,
          ...repTotals
        };
      });

      // ➕ ADD OFFICE TOTAL TO GRAND TOTAL
      this.grandCopies += officeTotals.totalSale;
      this.grandRetCopies += officeTotals.totalReturn;
      this.grandCompCopies += officeTotals.totalComp;
      this.grandBookPrices += officeTotals.totalBookp;
      this.grandSalePrice += officeTotals.totalSalePriceSum;   // NEW
      this.grandShipping += officeTotals.totalShipping;
      this.grandNet += officeTotals.totalNet;
      this.grandAmount += officeTotals.totalAmount;
      this.grandJama += officeTotals.totalReceipt;
      this.grandYene += officeTotals.totalPending;
      this.grandCommission += officeTotals.totalCommission;
      this.grandCredit += officeTotals.totalCredit;

      return {
        office_rep_name: office.office_rep_name,
        reps,
        ...officeTotals
      };
    });
  }

  // NEW: single object the "Grand Total" row can bind to safely
  get grandTotalData() {
    return {
      totalBookCopies: this.grandCopies,
      totalReturnCopies: this.grandRetCopies,
      totalCompCopies: this.grandCompCopies,
      totalBookPrice: this.grandBookPrices,
      totalSalePrice: this.grandSalePrice,
      totalNet: this.grandNet,
      totalShipping: this.grandShipping,
      totalAmount: this.grandAmount,
      totalReceived: this.grandJama,
      totalCredit: this.grandCredit,
      totalPending: this.grandYene,
      totalCommission: this.grandCommission
    };
  }

  // ================= RESET GRAND TOTAL =================
  resetGrandTotals() {
    this.grandCopies = 0;
    this.grandRetCopies = 0;
    this.grandCompCopies = 0;
    this.grandBookPrices = 0;
    this.grandSalePrice = 0;
    this.grandShipping = 0;
    this.grandNet = 0;
    this.grandAmount = 0;
    this.grandJama = 0;
    this.grandYene = 0;
    this.grandCommission = 0;
    this.grandCredit = 0;
  }

  // ================= PRINT ================= (unchanged)
  printPage4(): void {
    const printContent = document.getElementById('print-section');
    if (!printContent) return;

    const WindowPrt = window.open('', '', 'width=1600,height=1000');

    WindowPrt!.document.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <title>Book Registration Ledger Report</title>
          <style>
            * { -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; color-adjust: exact !important; box-sizing: border-box; }
            @page { size: A3 landscape; margin: 8mm; }
            body { margin: 0; padding: 0; font-family: Arial, sans-serif; font-size: 13px; color: #000; }
            #print-section { width: 99%; margin: 0 auto; }
            table { width: 100%; border-collapse: collapse; }
            th, td { border: 1px solid #000; padding: 3px 5px; vertical-align: middle; white-space: nowrap; }
            .text-end { text-align: right !important; }
            .text-start { text-align: left !important; }
            .text-center { text-align: center !important; }
            thead { display: table-header-group; }
            tfoot { display: table-row-group; }
            tr { page-break-inside: avoid; }
            @media print {
              .noPrint { display: none !important; }
              html, body { width: 100%; height: auto; }
            }
          </style>
        </head>
        <body>${printContent.innerHTML}</body>
      </html>
    `);

    WindowPrt!.document.close();
    WindowPrt!.focus();

    setTimeout(() => {
      WindowPrt!.print();
      WindowPrt!.close();
    }, 700);
  }

  // ================= EXCEL EXPORT ================= (unchanged)
  exportExcel(filename: string) {
    const table = document.getElementById('print-section');
    if (!table) return;

    const ws = XLSX.utils.table_to_sheet(table);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Report');
    XLSX.writeFile(wb, `${filename}.xlsx`);
  }
}